export default class MouseStalker {
  stalkerClassName: string
  stalkerElm: HTMLElement | null
  scrub: number
  stalkerPos: { x: number; y: number }
  mousePos: { x: number; y: number }
  rotation: number
  rotationSpeed: number
  imgSrc: string
  scale: number // ← 追加

  constructor(config: {
    stalkerClassName?: string
    scrub?: number
    imgSrc?: string
    rotationSpeed?: number
  }) {
    this.stalkerClassName = config.stalkerClassName || 'mouse_stalker'
    this.scrub = config.scrub || 0.1
    this.imgSrc =
      config.imgSrc ||
      `${document.location.origin}/wp-content/themes/OriginalThema/src/assets/image/mouse_cursor.png`
    this.rotationSpeed = config.rotationSpeed || 1.5
    this.stalkerElm = null
    this.stalkerPos = {
      x: document.documentElement.clientWidth * 0.9,
      y: document.documentElement.clientHeight * 0.9,
    }
    this.mousePos = {
      x: document.documentElement.clientWidth * 0.9,
      y: document.documentElement.clientHeight * 0.9,
    }
    this.rotation = 0
    this.scale = 1 // ← デフォルト倍率

    if (this.isTouchDevice()) return

    this.createStalker()
    document.addEventListener('mousemove', (e) => this.mousePosUpdate(e))
    requestAnimationFrame(this.stalkerPosUpdate)
    this.hoverAction() // ← hover 処理を呼ぶ
  }

  createStalker() {
    const div = document.createElement('div')
    div.classList.add(this.stalkerClassName)
    div.style.position = 'fixed'
    div.style.top = '0'
    div.style.left = '0'
    div.style.zIndex = '9999'
    div.style.pointerEvents = 'none'
    div.style.opacity = '0'
    div.style.willChange = 'transform'
    div.style.transition = 'transform 0.2s ease-out' // ← 滑らか拡大用

    const img = document.createElement('img')
    img.src = this.imgSrc
    img.alt = 'マウスストーカー'
    div.appendChild(img)

    this.stalkerElm = div
    document.body.appendChild(div)
  }

  mousePosUpdate(e: MouseEvent) {
    this.mousePos.x = e.clientX
    this.mousePos.y = e.clientY
    if (this.stalkerElm) this.stalkerElm.style.opacity = '1'
  }

  stalkerPosUpdate = () => {
    if (!this.stalkerElm) return

    this.stalkerPos.x += (this.mousePos.x - this.stalkerPos.x) * this.scrub
    this.stalkerPos.y += (this.mousePos.y - this.stalkerPos.y) * this.scrub

    this.rotation += this.rotationSpeed

    const x =
      Math.round(this.stalkerPos.x * 10) / 10 - this.stalkerElm.clientWidth / 2
    const y =
      Math.round(this.stalkerPos.y * 10) / 10 - this.stalkerElm.clientHeight / 2

    const offsetX = -2 // 左右にずらしたい量
    const offsetY = -3 // 上下にずらしたい量

    this.stalkerElm.style.transform = `translate3d(${x + offsetX}px, ${
      y + offsetY
    }px, 0) rotate(${this.rotation}deg) scale(${this.scale})`

    requestAnimationFrame(this.stalkerPosUpdate)
  }

  hoverAction() {
    const hoverTargets = document.querySelectorAll('a, button, [data-hover]')
    hoverTargets.forEach((el) => {
      el.addEventListener('mouseenter', () => (this.scale = 1.3))
      el.addEventListener('mouseleave', () => (this.scale = 1))
    })
  }

  isTouchDevice() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  }
}
